import curd from '../curd'

const BASE_PATH = '/avg/data'

export default curd(BASE_PATH, {
  getNormalAvgData: data => ({
    url: `${BASE_PATH}/granularity/routine`,
    method: 'POST',
    data: data
  }),
  getOtherAvgData: data => ({
    url: `${BASE_PATH}/granularity/other`,
    method: 'POST',
    data: data
  }),
  getVocsGroupAvgData: data => ({
    url: `${BASE_PATH}/granularity/voc/group`,
    method: 'POST',
    data: data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/AvgData.js